import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { User, Phone, Bank, MapPinLine, EnvelopeSimple } from 'phosphor-react';

import PageShell from './home-components/PageShell';
import FormField from './home-components/FormField';
import CustomAlert from './CustomAlert';
import CustomLoading from './CustomLoading';
import MessageTypes from 'enums/message-types';
import kediOturan from 'assets/img/home/kedi-oturan.png';

import { connect } from 'react-redux';
import { SEND_BUY_NOW_FORM, sendBuyNowForm } from 'redux/actions/pages';
import { removeMessage } from 'redux/actions/message';

const cities = [
  'ADANA',
  'ADIYAMAN',
  'AFYONKARAHİSAR',
  'AĞRI',
  'AMASYA',
  'ANKARA',
  'ANTALYA',
  'ARTVİN',
  'AYDIN',
  'BALIKESİR',
  'BİLECİK',
  'BİNGÖL',
  'BİTLİS',
  'BOLU',
  'BURDUR',
  'BURSA',
  'ÇANAKKALE',
  'ÇANKIRI',
  'ÇORUM',
  'DENİZLİ',
  'DİYARBAKIR',
  'EDİRNE',
  'ELAZIĞ',
  'ERZİNCAN',
  'ERZURUM',
  'ESKİŞEHİR',
  'GAZİANTEP',
  'GİRESUN',
  'GÜMÜŞHANE',
  'HAKKARİ',
  'HATAY',
  'ISPARTA',
  'MERSİN',
  'İSTANBUL',
  'İZMİR',
  'KARS',
  'KASTAMONU',
  'KAYSERİ',
  'KIRKLARELİ',
  'KIRŞEHİR',
  'KOCAELİ',
  'KONYA',
  'KÜTAHYA',
  'MALATYA',
  'MANİSA',
  'KAHRAMANMARAŞ',
  'MARDİN',
  'MUĞLA',
  'MUŞ',
  'NEVŞEHİR',
  'NİĞDE',
  'ORDU',
  'RİZE',
  'SAKARYA',
  'SAMSUN',
  'SİİRT',
  'SİNOP',
  'SİVAS',
  'TEKİRDAĞ',
  'TOKAT',
  'TRABZON',
  'TUNCELİ',
  'ŞANLIURFA',
  'UŞAK',
  'VAN',
  'YOZGAT',
  'ZONGULDAK',
  'AKSARAY',
  'BAYBURT',
  'KARAMAN',
  'KIRIKKALE',
  'BATMAN',
  'ŞIRNAK',
  'BARTIN',
  'ARDAHAN',
  'IĞDIR',
  'YALOVA',
  'KARABÜK',
  'KİLİS',
  'OSMANİYE',
  'DÜZCE',
];

const cityOptions = cities.map((c) => ({ value: c, label: c }));

export const noCityMessage = () => 'Şehir bulunamadı';

// Turkish- and accent-insensitive match, so "ist" finds İSTANBUL and
// "sanliurfa" finds ŞANLIURFA (react-select's default lowercasing does not
// handle İ/ı).
const foldTurkish = (text) =>
  text
    .toLocaleLowerCase('tr')
    .replace(/ı/g, 'i')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const filterCity = (option, input) =>
  foldTurkish(option.label).includes(foldTurkish(input));

const OFFER_INCLUDES = [
  'Okuma Ağacı: 13 seviyede 200+ sesli, resimli hikâye',
  'Ses Bilgisi: okul öncesi ve 1. sınıflar için ses temelli okuma modülü',
  'Öğretmen paneli: görev, materyal, ders planı ve sınıf raporları',
  'MEB kazanımlarıyla ilişkilendirilmiş kitaplar',
  'Web, iPad, iPhone ve Android uygulamaları',
];

function BuyNowPage({
  backendMessage,
  sendBuyNowForm,
  removeMessage,
  localizations,
}) {
  const [rod, setRod] = useState('');
  const [name, setName] = useState('');
  const [school, setSchool] = useState('');
  const [city, setCity] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (
      backendMessage &&
      backendMessage.messageContent !== undefined &&
      backendMessage.messageContent !== null &&
      backendMessage.messageContent !== ''
    ) {
      Swal.fire({
        icon: backendMessage.messageType || 'error',
        title:
          backendMessage.messageType === MessageTypes.success
            ? localizations?.MESSAGE_SUCCESS
            : localizations?.MESSAGE_ERROR,
        text: backendMessage.messageContent,
        showCancelButton: false,
        confirmButtonText: localizations?.MESSAGE_CONFIRM_BTN,
        confirmButtonColor: '#174b87',
      }).then((_) => {
        removeMessage(SEND_BUY_NOW_FORM);
        if (backendMessage.messageType === MessageTypes.success) {
          setRod('');
          setName('');
          setSchool('');
          setCity('');
          setEmail('');
          setPhone('');
          setMessage('');
        }
      });
    }
    // eslint-disable-next-line
  }, [backendMessage]);

  return (
    <>
      <CustomAlert />
      <CustomLoading />
      <PageShell
        path="/buy-now"
        kicker={localizations?.BUY_NOW_HEADER ?? 'Teklif İste'}
        title="Okulunuz için teklif alın"
        text={
          localizations?.BUY_NOW_DESC ??
          'Teklif almak için lütfen temsilcimiz ile iletişime geçiniz. Ya da formu doldurunuz biz sizinle iletişime geçelim.'
        }
      >
        <form
          id="contact-form"
          method="post"
          className="op-form-card buy-now-form"
        >
          <input
            className="op-hp"
            aria-label="Rod"
            autoComplete="off"
            tabIndex={-1}
            type="text"
            value={rod}
            onChange={(e) => setRod(e.target.value)}
          />
          <div className="op-form-row">
            <FormField
              id="buy-name"
              label={localizations?.FORM_NAME ?? 'İsim'}
              icon={User}
              required
            >
              <input
                id="buy-name"
                autoComplete="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </FormField>
            <FormField
              id="buy-school"
              label={localizations?.FORM_SCHOOL ?? 'Okul'}
              icon={Bank}
              required
            >
              <input
                id="buy-school"
                autoComplete="organization"
                type="text"
                value={school}
                onChange={(e) => setSchool(e.target.value)}
              />
            </FormField>
          </div>
          <div className="op-form-row">
            <FormField
              id="buy-city"
              label={localizations?.FORM_CITY ?? 'Şehir'}
              icon={MapPinLine}
              required
            >
              <Select
                inputId="buy-city"
                className="op-select"
                classNamePrefix="op-select"
                placeholder="Seçiniz"
                noOptionsMessage={noCityMessage}
                filterOption={filterCity}
                value={city}
                onChange={(value) => setCity(value)}
                options={cityOptions}
              />
            </FormField>
            <FormField
              id="buy-phone"
              label={localizations?.FORM_PHONE ?? 'Telefon No'}
              icon={Phone}
            >
              <input
                id="buy-phone"
                autoComplete="tel"
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </FormField>
          </div>
          <FormField
            id="buy-email"
            label={localizations?.FORM_EMAIL ?? 'Eposta'}
            icon={EnvelopeSimple}
            required
          >
            <input
              id="buy-email"
              autoComplete="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormField>
          <FormField id="message" label={localizations?.FORM_MESSAGE ?? 'Mesaj'}>
            <textarea
              id="message"
              name="message"
              rows="5"
              placeholder="Öğrenci sayısı, sınıf düzeyleri veya merak ettikleriniz…"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </FormField>
          <button
            className="op-btn op-btn--accent op-btn--lg op-form-card__submit"
            type="submit"
            onClick={(e) => {
              e.preventDefault();
              if (rod === '') {
                sendBuyNowForm({
                  name,
                  school,
                  city: city?.value,
                  email,
                  phone,
                  message,
                });
              }
            }}
          >
            {localizations?.FORM_SEND_BTN ?? 'Gönder'}
          </button>
        </form>

        <aside className="op-page__aside">
          <div className="op-info op-info--stack">
            <h2>Okulunuza neler sunuyoruz?</h2>
            <ul className="op-checks">
              {OFFER_INCLUDES.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="op-teaser">
            <img src={kediOturan} alt="" aria-hidden="true" />
            <h2>Önce sorularınız mı var?</h2>
            <p>Platformu okulunuzda nasıl kullanabileceğinizi birlikte konuşalım.</p>
            <a className="op-btn op-btn--ghost" href="/contact">
              İletişime geçin →
            </a>
          </div>
        </aside>
      </PageShell>
    </>
  );
}

const mapStateToProps = (state) => ({
  backendMessage: state.message[SEND_BUY_NOW_FORM],
  localizations: state.localization?.pairs,
});

const mapDispatchToProps = {
  sendBuyNowForm,
  removeMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(BuyNowPage);
